<template>
  <div class="home">
    <div class="home-content" v-if="$store.state.linkInfo.openLink || $store.state.linkInfo.resourceUrl">
      <template v-if="$store.state.linkInfo.openLink">
        <div class="gif-head">
          <img src="../../assets/loading-head.gif" />
        </div>
        <div class="gif-text">
          <img src="../../assets/loading-text.gif" />
        </div>
      </template>
    </div>
    <tip v-if="$store.state.errInfo.showTip" :getData="$store.state.errInfo.msg" @closeTip="closeTip"></tip>
  </div>
</template>

<script>
import { _mountedfun, _isMobile } from "../../views/utils/tools.js";
import tip from "../../components/tip";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      tip: "", //提示语
      showTip: false, //默认隐藏提示弹窗
      adsCode: "",
    };
  },
  components: {
    tip,
  },
  mounted() {
    _mountedfun(this)
  },
  methods: {
    closeTip() {
      //关闭提示弹窗
      this.$store.commit('setError', {
            msg: '',
            showTip: false
          })
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.gif-head {
  width: 100%;
  img {
    width: 80px;
    height: 80px;
  }
}
.gif-text {
  width: 100%;
  margin-top: 30px;
  img {
    width: 371px;
    height: 45px;
  }
}
.resource-img {
  width: 371px;
  height: 371px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
